import { format, differenceInYears } from 'date-fns'
import constantGenerate from '@/common/configs/constantGenerate'
import i18n from '@/member/langs/lang'

export function yyyyMMddhmm(value) {
  if (!value) return ''

  return format(new Date(value), 'yyyy/MM/dd HH:mm')
}

export function formatDate(value, formatValue = 'yyyy-MM-dd HH:mm:ss') {
  if (!value) return ''

  return format(new Date(value), formatValue)
}

export function fullName(value) {
  if (typeof value !== 'object' || !value) {
    return null
  }
  let firstName = value.first_name || ''
  let lastName = value.last_name || ''

  return lastName + ' ' + firstName
}

export function fullNameKana(value) {
  if (typeof value !== 'object' || !value) {
    return null
  }
  let firstNameKana = value.first_name_kana || ''
  let lastNameKana = value.last_name_kana || ''

  return lastNameKana + ' ' + firstNameKana
}

export function fullNameWithSpace(value, space = '　') {
  if (typeof value !== 'object' || !value) {
    return null
  }
  let firstName = value.first_name || ''
  let lastName = value.last_name || ''

  return lastName + (firstName ? space + firstName : firstName)
}

export function fullNameKanaWithSpace(value, space = '　') {
  if (typeof value !== 'object' || !value) {
    return null
  }
  let firstNameKana = value.first_name_kana || ''
  let lastNameKana = value.last_name_kana || ''

  return lastNameKana + (firstNameKana ? space + firstNameKana : firstNameKana)
}

export function gender(value) {
  if (!value) return ''

  if (value === constantGenerate.Customer.GENDER_MAN) {
    return i18n.t('common.option.gender.male')
  }
  if (value === constantGenerate.Customer.GENDER_WOMAN) {
    return i18n.t('common.option.gender.female')
  }

  return i18n.t('common.option.gender.other')
}

export function getGenderByGenderName(value) {
  if (!value) return ''

  if (value == i18n.t('common.option.gender.male')) {
    return constantGenerate.Customer.GENDER_MAN
  }

  if (value == i18n.t('common.option.gender.female')) {
    return constantGenerate.Customer.GENDER_WOMAN
  }

  if (value == i18n.t('common.option.gender.other')) {
    return constantGenerate.Customer.GENDER_OTHER
  }

  return 'undefined'
}

export function fullAddress(value) {
  if (typeof value !== 'object' || !value) {
    return null
  }

  let fullAddress = ''

  if (value.prefecture_id && value.prefecture) {
    fullAddress += value.prefecture.name
  }

  if (value.city) {
    fullAddress += value.city
  }

  if (value.house_number) {
    fullAddress += value.house_number
  }

  if (value.building_name) {
    fullAddress += ' ' + value.building_name
  }

  return fullAddress
}

export function yyyyMMddhhmmHyphen(value) {
  if (!value) return ''

  return format(new Date(value), 'yyyy-MM-dd HH:mm:ss')
}

export function subStringText(str, maxLengthText) {
  return str && str.length > maxLengthText ? str.substring(0, maxLengthText) + '...' : str
}

export function calcAge(startYear = new Date(), endYear = new Date()) {
  return differenceInYears(new Date(endYear), new Date(startYear))
}

export function memberFullName(member) {
  if (typeof member !== 'object' || !member) {
    return null
  }
  let firstName = member.first_name || ''
  let lastName = member.last_name || ''

  let fullName = lastName + ' ' + firstName
  let partnerName = member?.c_partner?.name || ''
  let divisionName = member?.c_division?.name || ''

  return (partnerName ? partnerName : divisionName) + ' ' + fullName
}

export function updatedAt(createdAt, updatedAt) {
  if (!createdAt || !updatedAt || createdAt === updatedAt) {
    return '-'
  }
  return format(new Date(updatedAt), 'yyyy/MM/dd HH:mm')
}

export function parseObjectToArray(object) {
  return Object.keys(object).map(key => object[key])
}

export function getNameOptionById(id, options = [], key = 'id', display = 'name') {
  if (typeof options == 'object') {
    options = Object.keys(options).map(index => options[index])
  }

  let result = options.find(item => {
    return item[key] == id
  })
  if (result) {
    return result[display]
  }

  return ''
}

export function getNameOptionsByIds(ids, options = [], key = 'id', display = 'name', separator = ',') {
  if (!ids || !ids.length) return ''

  if (typeof options == 'object') {
    options = Object.keys(options).map(index => options[index])
  }

  return options
    .filter(item => ids.indexOf(item[key]) != -1)
    .map(item => item[display])
    .join(separator)
}

export function toFixed(number, decimals = 2) {
  // 文字列ならそのまま返す
  if (typeof number === 'string') return number

  if (!number) return 0

  return parseFloat((Math.round(number * 10 ** decimals) / 10 ** decimals).toFixed(decimals)).toLocaleString()
}

export function numberFormat(str, suffix = '') {
  if (!str) return 0

  return String(str).replace(/(.)(?=(\d{3})+$)/g, '$1,') + suffix
}

export function livingArea(value) {
  if (!value) return ''

  if (value === constantGenerate.CCustomer.LIVING_AREA_DOMESTIC) {
    return i18n.t('common.option.living_area.domestic')
  }
  if (value === constantGenerate.CCustomer.LIVING_AREA_FOREIGN) {
    return i18n.t('common.option.living_area.foreign')
  }

  return ''
}

export function formatUnitNumber(unitNumber = '') {
  if (!unitNumber) {
    return ''
  }

  return `${unitNumber}号室`
}

/**
 * 万単位でない金額を「○万円」で表示する
 * @param number
 * @returns {string}
 */
export function formatPriceManYen(number) {
  if (!number) {
    return ''
  }

  if (!Number.isInteger(number)) {
    return number
  }

  const priceManYen = (number / 10000).toLocaleString()

  return `${priceManYen}万円`
}

export function convertYenToMan(number) {
  if (!number) {
    return ''
  }

  if (!Number.isInteger(number)) {
    return number
  }

  return (number / 10000).toString()
}

export function checkExistedItem(name, viewItems) {
  return viewItems.some(viewItem => viewItem === name) || false
}

export function number_cc(value) {
  if (!value) return ''
  return value.toLocaleString() + ' cc'
}

export function number_kg(value) {
  if (!value) return ''
  return value.toLocaleString() + ' kg'
}

export function number_cm(value) {
  if (!value) return ''
  return value.toLocaleString() + ' cm'
}

export function number_L(value) {
  if (!value) return ''
  return value.toLocaleString() + ' L'
}

export function number_temperature(value) {
  if (!value) return ''
  return value.toLocaleString() + ' ℃'
}

export function removeContentInBracket(str) {
  let indexOpenBracket = str.indexOf('（')

  return indexOpenBracket != -1 ? str.substring(0, indexOpenBracket) : str
}

export function formatNumber(value) {
  if (!value) return ''

  return Math.round(value).toLocaleString()
}

export function formatFloatNumber(str) {
  if (str === '' || str === null) return ''

  return str.toLocaleString()
}

export function expressInThousand(int) {
  if (!int) return 0

  if (Math.abs(int) < 1000) {
    return int.toLocaleString()
  } else {
    return Math.round(int / 1000).toLocaleString() + '千'
  }
}
